import { render } from "./TableExample.vue?vue&type=template&id=5b2d426b"
import script from "./TableExample.vue?vue&type=script&lang=js"
export * from "./TableExample.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__